module.exports = __webpack_public_path__ + "static/cover-a3dacf6fa26d1202237881551d31d19d.jpeg";